
import { privatePage, publicPage } from './mainRouter';

export const privateRouter = privatePage;

export const publicRouter = publicPage;
